/**
 * Category Filter Configuration
 *
 * Configuration for CategoryFilters component using GenericFilters.
 * Eliminates 229 lines of duplicated filter code.
 */

import type { FilterConfig } from '@/types/filter';
import type { CategoryFilters } from '@/types/category';
import {
  CategoryType,
  CategoryStatus,
  formatCategoryType,
  formatCategoryStatus,
} from '@/types/category';

export const categoryFilterConfig: FilterConfig<CategoryFilters> = {
  fields: [
    {
      key: 'type',
      type: 'select',
      label: 'Tipo',
      placeholder: 'Todos os tipos',
      options: [
        {
          value: CategoryType.INCOME,
          label: formatCategoryType(CategoryType.INCOME),
        },
        {
          value: CategoryType.EXPENSE,
          label: formatCategoryType(CategoryType.EXPENSE),
        },
      ],
    },
    {
      key: 'status',
      type: 'select',
      label: 'Status',
      placeholder: 'Todos os status',
      options: [
        {
          value: CategoryStatus.ACTIVE,
          label: formatCategoryStatus(CategoryStatus.ACTIVE),
        },
        {
          value: CategoryStatus.INACTIVE,
          label: formatCategoryStatus(CategoryStatus.INACTIVE),
        },
      ],
    },
  ],
  sortFields: [
    { key: 'name', label: 'Nome' },
    { key: 'type', label: 'Tipo' },
    { key: 'created_at', label: 'Data de criação' },
    { key: 'usage_count', label: 'Mais usadas' },
  ],
  defaultSortBy: 'name',
  defaultSortOrder: 'asc',
  formatFilterValue: (key, value) => {
    if (key === 'type') {
      return formatCategoryType(value as CategoryType);
    }
    if (key === 'status') {
      return formatCategoryStatus(value as CategoryStatus);
    }
    return String(value);
  },
};
